import { MaterialConditionDTO, MipMaterialClassificationDTOSchema } from '../generated';

export const camelToSnake = (value: string) => value.replace(/([A-Z])/g, '_$1').toLowerCase();

export const MATERIAL_PREDICTION_CLASSES = Object.keys(MipMaterialClassificationDTOSchema.properties.data.properties)
  .filter((className) => className !== 'ewcMapping')
  .map(camelToSnake) as MaterialConditionDTO['className'][];
